import React, { useState } from 'react';
import { ExternalLink, LayoutTemplate, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { builderUrl, cmsApi } from '../../../../lib/api/cms';
import { Button } from '../../../../components/ui/button';
import { Card, CardContent } from '../../../../components/ui/card';

/**
 * Einstieg in den ThunderBuilder ohne vorgewählte Seite. Der Editor läuft in
 * der Website (React 19); hier gibt es nur das Übergabe-Token und den Absprung.
 * Ein Link reicht dafür nicht: Das Token ist zwei Minuten gültig und muss im
 * Moment des Klicks geholt werden.
 */
const CmsBuilderPage: React.FC = () => {
  const [oeffnet, setOeffnet] = useState(false);

  // Fenster sofort öffnen, Ziel erst nach dem Token setzen — sonst blockt der
  // Browser das Popup, weil es nicht mehr direkt am Klick hängt.
  const oeffnen = async () => {
    const fenster = window.open('', '_blank');
    setOeffnet(true);
    try {
      const { token } = await cmsApi.getBuilderUebergabe();
      if (fenster) fenster.location.href = builderUrl(token);
      else window.location.href = builderUrl(token);
    } catch (e) {
      fenster?.close();
      toast.error(e instanceof Error ? e.message : 'Der Builder konnte nicht geöffnet werden');
    } finally {
      setOeffnet(false);
    }
  };

  return (
    <div className="mx-auto max-w-3xl space-y-6 p-4 sm:p-6">
      <div>
        <h1 className="text-2xl font-semibold">Seiten gestalten</h1>
        <p className="text-sm text-muted-foreground">
          Eigene Seiten visuell gestalten: Abschnitte anordnen, Formulare einfügen, Abstände und Farben einstellen – mit Vorschau
          für Handy, Tablet und Desktop.
        </p>
      </div>
      <Card>
        <CardContent className="space-y-4 py-6">
          <p className="text-sm">
            Der Editor öffnet sich in einem neuen Tab auf der Website. Dort wählst du oben die Seite. Die Blöcke einer Seite (Hero,
            Texte, Karten …) pflegst du weiter unter{' '}
            <Link to="/system/cms/seiten" className="text-primary underline-offset-2 hover:underline">
              Eigene Seiten
            </Link>
            ; von dort öffnet „Visuell gestalten“ den Editor gleich mit der passenden Seite.
          </p>
          <Button type="button" onClick={() => void oeffnen()} disabled={oeffnet}>
            {oeffnet ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <LayoutTemplate className="mr-2 h-4 w-4" />}
            Editor öffnen
            <ExternalLink className="ml-2 h-3.5 w-3.5" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CmsBuilderPage;
